<template>
  <div>
    <progress-bar class="c-progress-header" :value="5" :max="6" label="stappen">Progress</progress-bar>
    <h1 class="c-heading-1">Welke resultaten kan je verwachten?</h1>

    <p>Op basis van je antwoorden op de vragen  berekent de scan een uitkomst per trend in de vorm van een gekleurde bol.
    De kleur en de grootte van bol geeft aan hoe jij jezelf inschat.
    Hieraan koppelen wij adviezen.
    </p>
    <p>
    De grootte van de bol geeft aan hoe groot je de impact van deze trend inschat.
    De kleur van de bol geeft aan waar je vandaag al staat met deze trend, of je al stappen in deze richting hebt gezet.
    </p>
    <div class="c-results-info">
      <p>Een rode bol wijst er doorgaans op dat er nog een weg af te leggen is tussen waar je vandaag staat en waar je in jouw toekomstvisie naartoe wil. Enkele voorbeelden:</p>
      <div class="c-results-info__circle">
        <topic-circle
          :label="sphereCaption"
          :status="false"
          :size="sphereSize"
          :static="true"
          :showHalo="true"
        />
      </div>
      <div class="c-results-info__text">
      <div class="adviceLabel c-topic-label--red">{{adviceLabelHelperFunction(this.sphereSize,false)}}</div>
      <div>{{adviceSublabelHelperFunction(this.sphereSize,false)}}</div>
      </div>
    </div>
    <div class="c-results-info">
      <p>Een gele bol wijst erop dat je zeker de juiste mindset hebt en/of als bedrijf al stappen in die richting hebt gezet.  Enkele voorbeelden:</p>
      <div class="c-results-info__circle">
        <topic-circle
          :label="sphereCaption"
          :status="true"
          :size="sphereSize"
          :static="true"
          :showHalo="true"
        />
      </div>
      <div class="c-results-info__text">
        <div class="adviceLabel c-topic-label--green">{{adviceLabelHelperFunction(this.sphereSize,true)}}</div>
        <div>{{adviceSublabelHelperFunction(this.sphereSize,true)}}</div>
      </div>
    </div>

    <div class="c-toolbar">
      <navigation-button to="colleagues">Ga verder</navigation-button>
    </div>
  </div>
</template>

<script>
import AdviceMixin from '../mixins/Advice'
import NavigationButton from '../components/NavigationButton'
import TopicCircle from '../components/TopicCircle'
import ProgressBar from '../components/ProgressBar'
export default {
  mixins:[AdviceMixin],
  components: {
    NavigationButton,
    TopicCircle,
    ProgressBar
  },
  data () {
    return {
      timer: '',
      sphereSizes: [1,2,4],
      sphereIndex: 0,
      sphereSize: 1,
      status: true
    }
  },
  created: function() {
    this.timer = setInterval(this.changeSphereSize, 2500)
  },
  computed: {
    sphereCaption () {
      if(this.sphereSize >= 1 && this.sphereSize < 3)
        return "klein aandachtspunt";
      else
        return "groot aandachtspunt";
    }
  },
  methods: {
      changeSphereSize: function() {
        this.sphereIndex = this.sphereIndex + 1;
        if(this.sphereIndex >= this.sphereSizes.length)
          this.sphereIndex = 0;
        this.sphereSize = this.sphereSizes[this.sphereIndex];
      }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
}
</script>

<style lang="scss">
@import '../assets/styles/variables';

.c-results-info {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  margin: 4rem 0;
}

.c-results-info__circle {
  flex: none;
  margin-right: 4rem;
}

.c-results-info__text {
  flex: 1 1 0;
}

.adviceLabel {
  font-weight:bold;
}

.c-topic-label--green {
  color: $green;
}

.c-topic-label--red {
  color: $red;
}

</style>
